/**
 * Subconjuntos de los catálogos del Anexo 20 que usamos en el día a día.
 *
 * Los catálogos grandes (c_ClaveProdServ tiene ~52,000 filas, c_ClaveUnidad
 * ~2,400, c_CodigoPostal ~100,000) viven en tablas de Postgres, no aquí.
 * Estos son los cortos y estables, que conviene tener como tipos.
 */
export const TIPO_COMPROBANTE = {
    I: "Ingreso",
    E: "Egreso",
    T: "Traslado",
    N: "Nómina",
    P: "Pago",
};
export const METODO_PAGO = {
    PUE: "Pago en una sola exhibición",
    PPD: "Pago en parcialidades o diferido",
};
export const FORMA_PAGO = {
    "01": "Efectivo",
    "02": "Cheque nominativo",
    "03": "Transferencia electrónica de fondos",
    "04": "Tarjeta de crédito",
    "05": "Monedero electrónico",
    "06": "Dinero electrónico",
    "08": "Vales de despensa",
    "12": "Dación en pago",
    "13": "Pago por subrogación",
    "14": "Pago por consignación",
    "15": "Condonación",
    "17": "Compensación",
    "23": "Novación",
    "24": "Confusión",
    "25": "Remisión de deuda",
    "26": "Prescripción o caducidad",
    "27": "A satisfacción del acreedor",
    "28": "Tarjeta de débito",
    "29": "Tarjeta de servicios",
    "30": "Aplicación de anticipos",
    "31": "Intermediario pagos",
    "99": "Por definir",
};
export const MONEDA = {
    MXN: "Peso Mexicano",
    USD: "Dólar americano",
    EUR: "Euro",
    XXX: "Los códigos asignados para las transacciones en que intervenga ninguna moneda",
};
export const EXPORTACION = {
    "01": "No aplica",
    "02": "Definitiva con clave del pedimento A1",
    "03": "Temporal",
    "04": "Definitiva con clave distinta a A1",
};
export const USO_CFDI = {
    G01: "Adquisición de mercancías",
    G02: "Devoluciones, descuentos o bonificaciones",
    G03: "Gastos en general",
    I01: "Construcciones",
    I02: "Mobiliario y equipo de oficina por inversiones",
    I03: "Equipo de transporte",
    I04: "Equipo de cómputo y accesorios",
    I05: "Dados, troqueles, moldes, matrices y herramental",
    I06: "Comunicaciones telefónicas",
    I07: "Comunicaciones satelitales",
    I08: "Otra maquinaria y equipo",
    D01: "Honorarios médicos, dentales y gastos hospitalarios",
    D02: "Gastos médicos por incapacidad o discapacidad",
    D03: "Gastos funerales",
    D04: "Donativos",
    D05: "Intereses reales efectivamente pagados por créditos hipotecarios",
    D06: "Aportaciones voluntarias al SAR",
    D07: "Primas por seguros de gastos médicos",
    D08: "Gastos de transportación escolar obligatoria",
    D09: "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones",
    D10: "Pagos por servicios educativos (colegiaturas)",
    S01: "Sin efectos fiscales",
    CP01: "Pagos",
    CN01: "Nómina",
};
export const REGIMEN_FISCAL = {
    "601": "General de Ley Personas Morales",
    "603": "Personas Morales con Fines no Lucrativos",
    "605": "Sueldos y Salarios e Ingresos Asimilados a Salarios",
    "606": "Arrendamiento",
    "607": "Régimen de Enajenación o Adquisición de Bienes",
    "608": "Demás ingresos",
    "610": "Residentes en el Extranjero sin Establecimiento Permanente en México",
    "611": "Ingresos por Dividendos (socios y accionistas)",
    "612": "Personas Físicas con Actividades Empresariales y Profesionales",
    "614": "Ingresos por intereses",
    "615": "Régimen de los ingresos por obtención de premios",
    "616": "Sin obligaciones fiscales",
    "620": "Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
    "621": "Incorporación Fiscal",
    "622": "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
    "623": "Opcional para Grupos de Sociedades",
    "624": "Coordinados",
    "625": "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
    "626": "Régimen Simplificado de Confianza",
};
export const OBJETO_IMP = {
    "01": "No objeto de impuesto",
    "02": "Sí objeto de impuesto",
    "03": "Sí objeto del impuesto y no obligado al desglose",
    "04": "Sí objeto del impuesto y no causa impuesto",
    "05": "Sí objeto del impuesto, IVA crédito PODEBI",
    "06": "Sí objeto del IVA, No traslado IVA",
    "07": "No traslado del IVA, Sí desglose IEPS",
};
export const IMPUESTO = {
    "001": "ISR",
    "002": "IVA",
    "003": "IEPS",
};
export const TIPO_FACTOR = {
    Tasa: "Tasa",
    Cuota: "Cuota",
    Exento: "Exento",
};
/**
 * Motivos de cancelación (vigentes desde CFDI 4.0).
 * El 01 obliga a mandar el UUID del comprobante que sustituye.
 */
export const MOTIVO_CANCELACION = {
    "01": "Comprobante emitido con errores con relación",
    "02": "Comprobante emitido con errores sin relación",
    "03": "No se llevó a cabo la operación",
    "04": "Operación nominativa relacionada en una factura global",
};
export const TIPO_RELACION = {
    "01": "Nota de crédito de los documentos relacionados",
    "02": "Nota de débito de los documentos relacionados",
    "03": "Devolución de mercancía sobre facturas o traslados previos",
    "04": "Sustitución de los CFDI previos",
    "05": "Traslados de mercancías facturados previamente",
    "06": "Factura generada por los traslados previos",
    "07": "CFDI por aplicación de anticipo",
};
/** El RFC genérico para operaciones con el público en general. */
export const RFC_PUBLICO_GENERAL = "XAXX010101000";
/** El RFC genérico para residentes en el extranjero. */
export const RFC_EXTRANJERO = "XEXX010101000";
const claves = (c) => Object.keys(c);
/**
 * Entradas de un catálogo ordenadas por clave, para pintar selectores.
 *
 * `Object.entries()` NO respeta el orden de escritura: JavaScript adelanta
 * las claves que parecen enteros y las ordena numéricamente. Como en los
 * catálogos del SAT conviven "01" (no es entero, conserva su lugar) y "12"
 * (sí lo es, se va al principio), un `<select>` de formas de pago termina
 * mostrando 12, 13, … 99, 01, 02, 03. Ordenar como texto lo deja como el
 * Anexo 20.
 */
export const entradasOrdenadas = (catalogo) => Object.entries(catalogo).sort((a, b) => a[0].localeCompare(b[0], "es"));
export const CLAVES = {
    tipoComprobante: claves(TIPO_COMPROBANTE),
    metodoPago: claves(METODO_PAGO),
    formaPago: claves(FORMA_PAGO),
    moneda: claves(MONEDA),
    exportacion: claves(EXPORTACION),
    usoCfdi: claves(USO_CFDI),
    regimenFiscal: claves(REGIMEN_FISCAL),
    objetoImp: claves(OBJETO_IMP),
    impuesto: claves(IMPUESTO),
    tipoFactor: claves(TIPO_FACTOR),
    motivoCancelacion: claves(MOTIVO_CANCELACION),
    tipoRelacion: claves(TIPO_RELACION),
};
//# sourceMappingURL=catalogos.js.map